// extracted by mini-css-extract-plugin
export var cell = "_50-4";
export var headerCell = "_50-2";
export var rowHeader = "_50-3";
export var table = "_50-1";
export var tableContainer = "_50-0";